import React from 'react'
import AuthorizationProvider from '../containers/AuthorizationProvider/AuthorizationProvider.container'
import BrandLayout from '../components/Layouts/BrandLayout'
import FooterSectionContainer from '../containers/FooterSection/FooterSection.container'
import HeaderSectionContainer from '../containers/HeaderSection/HeaderSection.container'
import HomeFormContainer from '../containers/HomeForm/HomeForm.container'
import ProtectByAccessToken from '../components/Security/ProtectByAccessToken'
import NotFoundPage from './NotFound'

/**
 * The Home's page.
 */
const Home = () => {
  return (
    <AuthorizationProvider>
      <ProtectByAccessToken fallback={() => <NotFoundPage />} rule={isValid => isValid}>
        <BrandLayout footer={<FooterSectionContainer />} header={<HeaderSectionContainer />}>
          <HomeFormContainer />
        </BrandLayout>
      </ProtectByAccessToken>
    </AuthorizationProvider>
  )
}

export default Home
